// Screen `tasks` (owner: task-platform): all tasks as data — table, board and calendar with typed filters
// and saved views. The links of the former task page (`?task=`, `?item=`, `?view=`) still open the Inbox.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { FilterNodeSchema } from '@dataroom/core';
import { TasksPage } from '../../../features/tasks/TasksPage';
import { CalendarMonthSchema, TasksLayoutSchema } from '../../../features/tasks/inputs';

export const Route = createFileRoute('/_app/tasks/')({
  validateSearch: z.object({
    layout: TasksLayoutSchema.optional().catch(undefined),
    v: z.string().max(80).optional().catch(undefined),
    // The filter as the router writes it: a filter node (null = deliberately none), else the view's own.
    // A link can carry anything here: a filter that does not check is dropped (the view's own applies).
    f: FilterNodeSchema.nullable().optional().catch(undefined),
    group: z.string().max(63).optional().catch(undefined),
    sort: z.string().max(80).optional().catch(undefined),
    // The table's columns (field keys, in order) and the field its rows are grouped by.
    cols: z.string().max(1200).optional().catch(undefined),
    tgroup: z.string().max(63).optional().catch(undefined),
    q: z.string().max(200).optional().catch(undefined),
    month: CalendarMonthSchema.optional().catch(undefined),
    open: z.uuid().optional().catch(undefined),
    task: z.string().optional(),
    item: z.string().optional(),
    view: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.item || search.view || search.task)
      throw redirect({
        to: '/inbox',
        search: {
          item: search.task ? `task:${search.task}` : search.item,
          tab: search.view === 'updates' ? 'updates' : search.view === 'history' ? 'done' : 'for-you',
        },
        replace: true,
      });
  },
  component: function TasksRoute() {
    return <TasksPage search={Route.useSearch()} />;
  },
});
